import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserLink } from '../activityTypes/userLink/userLink';
import { CardField, UserActivityCard } from './userActivityCard';
import { humanize, statusColors } from './userActivityTypes.utils';

type AgentBannedUserProps = {
  entry: UserAuditLogEntry<'AGENT_BANNED_USER'>;
};

export const AgentBannedUser = ({
  entry,
}: AgentBannedUserProps): JSX.Element => {
  const channels = entry.channel_ref.map(humanize).join(', ');
  const fields: CardField[] = [
    { label: 'Reason', value: entry.reason },
    {
      label: 'Expires',
      value: entry.expected_end_time
        ? new Date(entry.expected_end_time).toLocaleString()
        : undefined,
    },
    {
      label: 'IP address',
      value: entry.ip_address,
      copyText: entry.ip_address,
    },
  ].filter((field) => field.value);

  return (
    <UserActivityCard
      entry={entry}
      icon="user-slash"
      color={statusColors.negative}
      title="Banned"
      titleSuffix={
        <UserLink
          userId={entry.user_id}
          onClick={(event) => event.stopPropagation()}
        >
          {entry.user_name ?? entry.user_id}
        </UserLink>
      }
      summary={channels || undefined}
      fields={fields}
    />
  );
};
